import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Heart, Activity, Scale } from 'lucide-react';

export function StressScoreInfo() {
  const factors = [
    {
      icon: <Heart className="w-4 h-4" />,
      name: "Heart Rate Variability",
      weight: "40%",
      description: "Measures autonomic nervous system balance"
    },
    {
      icon: <Activity className="w-4 h-4" />,
      name: "Activity Level",
      weight: "30%",
      description: "Physical and mental exertion"
    },
    {
      icon: <Brain className="w-4 h-4" />,
      name: "Recovery Status",
      weight: "30%",
      description: "Overall recovery and readiness"
    }
  ];

  return (
    <div className="theme-card p-6 bg-gradient-to-br from-background/50 to-background/30 backdrop-blur-md">
      <h3 className="text-lg font-medium mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary via-purple-400 to-blue-500">
        Understanding Your Stress Score
      </h3>
      
      <div className="grid gap-4">
        {factors.map((factor, index) => (
          <motion.div
            key={factor.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="p-4 rounded-lg bg-gradient-to-r from-primary/5 via-purple-500/5 to-transparent border border-primary/10"
          >
            <div className="flex items-center gap-3">
              <div className="relative">
                {factor.icon}
                <div className="absolute inset-0 bg-current opacity-20 blur-xl rounded-full" />
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-medium">{factor.name}</span>
                  <span className="text-xs text-primary bg-primary/10 px-2 py-0.5 rounded-full">
                    {factor.weight}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground mt-1">
                  {factor.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-4 p-4 rounded-lg bg-primary/5 border border-primary/10">
        <div className="flex items-center gap-2 text-sm">
          <Scale className="w-4 h-4 text-primary" />
          <span className="font-medium">Final Score Calculation</span>
        </div>
        <p className="text-xs text-muted-foreground mt-2">
          Your stress score is calculated by combining these factors using advanced algorithms that account for their relative importance and interactions. The score updates in real-time as your metrics change throughout the day.
        </p>
      </div>
    </div>
  );
}